import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ThemeService } from 'src/app/services/base/theme.service';

@Component({
  selector: 'app-my-icon-button',
  templateUrl: './my-icon-button.component.html',
  styleUrls: ['./my-icon-button.component.scss']
})
export class MyIconButtonComponent implements OnInit {
  @Input() icon:string = "";
  @Output() myClick =  new EventEmitter();
  
  constructor(public theme:ThemeService) { }

  ngOnInit(): void {
  }

  onClick(){
    this.myClick.emit();
  }

}
